<template>
  <div class="content-wrapper">
    <!-- Admin -->
    <div v-if="isRuejaiPartnerAdmin" class="form-wrapper">
      <div class="item-wrapper">
        <p>เลขที่ใบแจ้งหนี้</p>
        <el-input v-model="invoiceNo" type="text" clearable />
      </div>
      <div class="item-wrapper">
        <p>โครงการ</p>
        <el-select
          id="projectId"
          v-model="projectId"
          :filter-method="handleSearchProject"
          name="projectId"
          filterable
          clearable
          placeholder="เลือกโครงการ"
        >
          <el-option
            v-for="project in projectOptions"
            :key="project.id"
            :value="project.id"
            :label="project.label"
          />
        </el-select>
      </div>
      <div class="item-wrapper">
        <p>รอบใบแจ้งหนี้</p>
        <el-date-picker
          v-model="fulfilledAtFrom"
          placeholder="เลือกรอบใบแจ้งหนี้"
          format="MMMM yyyy"
          type="month"
        />
      </div>
      <div class="item-wrapper">
        <p>ถึง</p>
        <el-date-picker
          v-model="fulfilledAtTo"
          :placeholder="
            isSelectedFulfilledAtFrom
              ? 'เลือกรอบใบแจ้งหนี้'
              : 'กรุณาเลือกรอบใบแจ้งหนี้'
          "
          :disabled="!isSelectedFulfilledAtFrom"
          format="MMMM yyyy"
          type="month"
        />
      </div>
    </div>

    <!-- Partner -->
    <div v-else class="form-wrapper">
      <div class="item-wrapper">
        <p>วันที่แจ้ง</p>
        <el-date-picker
          v-model="createdAtFrom"
          placeholder="เลือกวันที่แจ้ง"
          format="dd MMMM yyyy"
          type="date"
        />
      </div>
      <div class="item-wrapper">
        <p>ถึง</p>
        <el-date-picker
          v-model="createdAtTo"
          :placeholder="
            isSelectedCreatedAtFrom ? 'เลือกวันที่แจ้ง' : 'กรุณาเลือกวันที่แจ้ง'
          "
          :disabled="!isSelectedCreatedAtFrom"
          format="dd MMMM yyyy"
          type="date"
        />
      </div>
      <div class="item-wrapper">
        <p>เลขที่ใบแจ้งหนี้</p>
        <el-input v-model="invoiceNo" type="text" clearable />
      </div>
      <div class="item-wrapper">
        <p>โครงการ</p>
        <el-select
          id="projectId"
          v-model="projectId"
          :filter-method="handleSearchProject"
          name="projectId"
          filterable
          clearable
          placeholder="เลือกโครงการ"
        >
          <el-option
            v-for="project in projectOptions"
            :key="project.id"
            :value="project.id"
            :label="project.label"
          />
        </el-select>
      </div>
      <div class="item-wrapper">
        <p>รอบใบแจ้งหนี้</p>
        <el-date-picker
          v-model="fulfilledAtFrom"
          placeholder="เลือกรอบใบแจ้งหนี้"
          format="MMMM yyyy"
          type="month"
        />
      </div>
      <div class="item-wrapper">
        <p>ถึง</p>
        <el-date-picker
          v-model="fulfilledAtTo"
          :placeholder="
            isSelectedFulfilledAtFrom
              ? 'เลือกรอบใบแจ้งหนี้'
              : 'กรุณาเลือกรอบใบแจ้งหนี้'
          "
          :disabled="!isSelectedFulfilledAtFrom"
          format="MMMM yyyy"
          type="month"
        />
      </div>
    </div>

    <!-- Button -->
    <div class="button-wrapper">
      <button class="button reset-button ms-2" @click="handleClearFilter">
        <img src="/static/icons/supplier-close-icon.svg" />ยกเลิก
      </button>
      <button class="button search-button ms-2" @click="handleSearchSubmit">
        <img src="/static/icons/supplier-search-icon.svg" />ค้นหา
      </button>
    </div>
  </div>
</template>

<script>
import { DateTime } from "luxon"
import { mSize } from "../StaticVariable"
import { permissionRole } from "../../lib/mapper"

export default {
  props: {
    projects: {
      type: null,
      default: undefined,
    },
    status: {
      type: null,
      default: undefined,
    },
    activeStatus: {
      type: null,
      default: undefined,
    },
  },
  data() {
    return {
      windowWidth: window.innerWidth,
      roleId: parseInt(localStorage.getItem("supplierRoleId"), 10),
      projectQuery: "",
      invoiceNo: null,
      projectId: null,
      createdAtFrom: null,
      createdAtTo: null,
      fulfilledAtFrom: null,
      fulfilledAtTo: null,
    }
  },
  computed: {
    isDesktop() {
      return this.windowWidth >= mSize
    },
    projectOptions() {
      if (!this.projectQuery) {
        return this.projects
      }

      return this.projects.filter((project) =>
        project.label.includes(this.projectQuery),
      )
    },
    isSelectedCreatedAtFrom() {
      return this.createdAtFrom
    },
    isSelectedFulfilledAtFrom() {
      return this.fulfilledAtFrom
    },
    isRuejaiPartnerAdmin() {
      return this.roleId === permissionRole.RJPADMIN
    },
  },
  watch: {
    createdAtFrom(value) {
      if (!value) {
        this.createdAtTo = null
      }
    },
    fulfilledAtFrom(value) {
      if (!value) {
        this.fulfilledAtTo = null
      }
    },
  },
  created() {
    this.setup()
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize)
    })
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize)
  },
  methods: {
    setup() {
      this.setupQueryParameters()
    },
    setupQueryParameters() {
      if (this.status === this.activeStatus) {
        const {
          invoice_no: invoiceNo,
          project_id: projectId,
          created_at_from: createdAtFrom,
          created_at_to: createdAtTo,
          fulfilled_at_from: fulfilledAtFrom,
          fulfilled_at_to: fulfilledAtTo,
        } = this.$route.query

        if (invoiceNo) this.invoiceNo = invoiceNo
        if (projectId) this.projectId = projectId
        if (createdAtFrom)
          this.createdAtFrom = new Date(parseInt(createdAtFrom, 10))
        if (createdAtTo) this.createdAtTo = new Date(parseInt(createdAtTo, 10))
        if (fulfilledAtFrom)
          this.fulfilledAtFrom = new Date(parseInt(fulfilledAtFrom, 10))
        if (fulfilledAtTo)
          this.fulfilledAtTo = new Date(parseInt(fulfilledAtTo, 10))
      }
    },
    onResize() {
      this.windowWidth = window.innerWidth
    },
    handleSearchProject(query) {
      this.projectQuery = query
    },
    handleSearchSubmit() {
      const query = {}

      if (this.invoiceNo) query.invoiceNo = this.invoiceNo
      if (this.projectId) query.projectId = this.projectId
      if (this.createdAtFrom)
        query.createdAtFrom = DateTime.fromJSDate(this.createdAtFrom)
      if (this.createdAtTo)
        query.createdAtTo = DateTime.fromJSDate(this.createdAtTo).endOf("day")
      if (this.fulfilledAtFrom)
        query.fulfilledAtFrom = DateTime.fromJSDate(
          this.fulfilledAtFrom,
        ).startOf("month")
      if (this.fulfilledAtTo) {
        query.fulfilledAtTo = DateTime.fromJSDate(this.fulfilledAtTo).endOf(
          "month",
        )
      } else if (this.fulfilledAtFrom) {
        query.fulfilledAtTo = DateTime.fromJSDate(this.fulfilledAtFrom).endOf(
          "month",
        )
      }

      this.$emit("searchSubmit", query)
    },
    clearFilter() {
      this.invoiceNo = null
      this.projectId = null
      this.createdAtFrom = null
      this.createdAtTo = null
      this.fulfilledAtFrom = null
      this.fulfilledAtTo = null
    },
    handleClearFilter() {
      this.clearFilter()

      this.$emit("clearFilter", "")
    },
    handleCreateInvoice() {
      this.clearFilter()

      this.$emit("searchSubmit", "")
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../css/otherWebVariables";
.content-wrapper {
  display: flex;
  flex-direction: column;
  height: auto;
  overflow: auto;

  .form-wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: 1fr;
    grid-gap: 16px;
    padding: 24px;
  }

  .item-wrapper {
    display: flex;
    flex-direction: column;
  }

  .button-wrapper {
    margin-inline: 24px;
    margin-bottom: 24px;
    text-align: right;
  }
}

.button {
  padding-inline: 12px;
  height: 40px;
  font-weight: bold;
  font-size: $font-16;
  border-radius: 8px;
  align-items: center;

  img {
    margin-right: 8px;
  }
}

.search-button {
  background: transparent;
  border: 1px solid $supplier-primary-color;
  color: $supplier-primary-color;
  margin-left: 16px;

  &:hover:not(:disabled) {
    background: $color-light-gray-1-hover;
  }
}

.reset-button {
  color: $black;
  background: transparent;
  border: 1px solid $color-light-gray-1;

  &:hover:not(:disabled) {
    background: $color-light-gray-1-hover;
  }
}

p {
  font-size: $font-14;
}

.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}

@media (max-width: ($m-size - 1)) {
  .content-wrapper {
    .form-wrapper {
      grid-template-columns: 1fr 1fr;
      grid-template-rows: 1fr 1fr;
      grid-gap: 12px;
      padding: 16px;
    }

    .button-wrapper {
      margin-inline: 16px;
      margin-bottom: 16px;
    }
  }

  .search-button {
    margin-left: 8px;
  }
}

@media (min-width: $m-size) and (max-width: ($ml-size - 1)) {
  .content-wrapper {
    .form-wrapper {
      grid-template-columns: 1fr 1fr;
      grid-template-rows: 1fr 1fr;
      grid-gap: 16px;
      padding: 16px;
    }

    .button-wrapper {
      margin-inline: 16px;
      margin-bottom: 24px;
    }
  }

  .search-button {
    margin-left: 12px;
  }
}
</style>
